var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19853 8.6789H4L11.3842 4L18.4542 8.6789H17.4128M5.19853 8.6789V18M5.19853 8.6789H17.4128M17.4128 8.6789V11",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8353 12.5781V21.2043H32V27.8007H10.5059V12.5781H24.8353Z",
    fill: "#12D9E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9344 16.7754H25.0078V21.2093H31.166L28.9344 16.7754Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6282 21.4792L28.9344 16.7754H25.0078V23.8618",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1194 29.3734C18.1194 30.5543 17.1735 31.5026 16.0177 31.5026C14.8618 31.5026 13.9159 30.5543 13.9159 29.3734C13.9159 28.1925 14.8618 27.2441 16.0177 27.2441C17.1735 27.2441 18.1194 28.1925 18.1194 29.3734Z",
    fill: "white",
    stroke: "#383434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2699 29.3734C29.2699 30.5543 28.324 31.5026 27.1682 31.5026C26.0123 31.5026 25.0664 30.5543 25.0664 29.3734C25.0664 28.1925 26.0123 27.2441 27.1682 27.2441C28.324 27.2441 29.2699 28.1925 29.2699 29.3734Z",
    fill: "white",
    stroke: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodIcon);
export default __webpack_public_path__ + "static/media/codIcon.d14f2aaaa0deb950ceee58aed49e066b.svg";
export { ForwardRef as ReactComponent };